"use strict";

(function mainThemeScript($, Drupal, drupalSettings) {
  Drupal.behaviors.pages = {
    attach: function attach(context, settings) {

      $('.node__content').addClass(function () {
        return ["none", "one", "two", "three", "four"][$(this).children('div').length];
      });

      $('.field--name-field-cta').closest('.node__content').addClass('with-cta');

      $('.node__content.with-cta').children('div.field:not(.field--name-field-cta)').wrapAll("<div class='left_content'></div>");
    }
  };

  //var count = $("ul li").length;
  Drupal.behaviors.biofinMenu = {
    attach: function attach(context, settings) {
      $(context).find('#block-biofin-main-menu .menu').superfish({
        //$('#block-biofin-main-menu .menu', context).superfish({
        autoArrows: false,
        cssArrows: false,
        disableHI: true });
    }
  };
  Drupal.behaviors.biofinBef = {
    attach: function attach(context, settings) {
      // form ID views-exposed-form-knowledge-platform-block-1
      //$('#block-biofin-views-block-knowledge-platform-block-1')
      // $('.view-knowledge-platform ')
      // override some chosen stuff
      if ($('body').hasClass('page-node-470')) {
        $('#custom-apply').click(function (event) {
          //if (event.keyCode == 13) {
          $('.bef-exposed-form  .button.form-submit').once().click();

          // Since this form has too much going on with AJAX, etc. the indicator keeps staying
          // We will run some JS a few times to get rid of it, hoping the search has completed.
          var time = 1;
          var interval = setInterval(function() {
            if (time <= 5) {
              $('div').remove(".ajax-progress");
              time++;
            }
          }, 3000);

          //}
        });
      }
      if ($('body').hasClass('path-knowledge-base')) {
        var editsecondary = $('<div/>').attr({
          'id': 'edit-secondary'
        }).append('<div id="edit-secondary-inner" class="content-wrapper--max container-fluid container"></div>');

        //let a = $('.form-item-field-country-target-id');
        var a = $('.form-item-country');
        var b = $('.form-item-type');
        var c = $('.form-item-topic');
        var d = $('.form-item-region');
        var e = $('<div class="button" id="custom-apply"><span><i class="fas fa-search"></i></span></div>');
        var z = $('#edit-submit-knowledge-platform');
        // let x = $('.form-actions.js-form-wrapper.form-wrapper');


        $('#views-exposed-form-knowledge-platform-block-1 .form-item-keys').once().wrap('<div id="edit-primary"></div>');
        //$('.form-item-keys input').once().after('<i class="fa fa-search" aria-hidden="true"></i>');
        $('#views-exposed-form-knowledge-platform-block-1 .form-item-keys input').once().after('<i class="fa fa-search"></i>');

        $('#edit-primary').once().after(editsecondary);

        $('#edit-secondary-inner').once().append(a).append(b).append(c).append(d).append(e);
        $('#edit-secondary').once().prepend('<div class="container container-fluid"><div class="row"><div class="col-md-12 col-xs-12 lead-14 m-padding-bottom-10 m-weight-600"> <span>FILTER RESULTS</span></div></div></div>');

        $('#views-exposed-form-knowledge-platform-block-1 .fa-search').click(function (event) {
          //if (event.keyCode == 13) {
          $('.bef-exposed-form  .button.form-submit').click();
          //}
        });

        $('#custom-apply').click(function (event) {
          //if (event.keyCode == 13) {
          $('.bef-exposed-form  .button.form-submit').click();
          //}
        });

        $('#views-exposed-form-knowledge-platform-block-1 .form-item-keys').keyup(function (event) {
          if (event.keyCode == 13) {
            $('.bef-exposed-form  .button.form-submit').click();
          }
        });
        // var companyElements = $("ul:data(group) li:data(company)");
        // data-drupal-selector = edit-type
        // Only work on first page load
        $('#edit-country', context).chosen({
          placeholder_text_multiple: 'Choose Countries to Filter'
        });
        $('#edit-type').chosen({
          placeholder_text_multiple: 'Choose Knowledge Types to Filter'
        });
        $('#edit-topic').chosen({
          placeholder_text_multiple: 'Choose Topics to Filter'
        });
      }
    }
  };

  Drupal.behaviors.flexOrder = {
    attach: function attach(context, settings) {
      if ($('body').hasClass('page-node-30')) {
        var length = $('.team-wrapper .card').length + 6;

        for (var i = 1; i < length; i = i + 6) {
          //console.log(i);
          var index = i - 1;
          var order = i;
          $(context).find('.team-wrapper .card').eq(index).addClass('flex-order-' + order).css({
            'order': order
          });
        }
        for (var i = 2; i < length; i = i + 6) {
          var _index = i - 1;
          var _order = i + 2;
          //console.log(i);
          $(context).find('.team-wrapper .card').eq(_index).addClass('flex-order-' + _order).css('order', _order);
        }
        for (var i = 3; i < length; i = i + 6) {
          var _index2 = i - 1;
          var _order2 = i - 1;
          //console.log(i);
          $(context).find('.team-wrapper .card').eq(_index2).addClass('flex-order-' + _order2).css('order', _order2);
        }

        for (var i = 4; i < length; i = i + 6) {
          var _index3 = i - 1;
          var _order3 = i + 1;
          //console.log(i);
          $(context).find('.team-wrapper .card').eq(_index3).addClass('flex-order-' + _order3).css('order', _order3);
        }

        for (var i = 5; i < length; i = i + 6) {
          //console.log(i);
          var _index4 = i - 1;
          var _order4 = i - 2;
          $(context).find('.team-wrapper .card').eq(_index4).addClass('flex-order-' + _order4).css('order', _order4);
        }
        for (var i = 6; i < length; i = i + 6) {
          //console.log(i);
          var _index5 = i - 1;
          var _order5 = i;
          $(context).find('.team-wrapper .card').eq(_index5).addClass('flex-order-' + _order5).css('order', _order5);
        }
        //
        $('.card.pix', context).click(function () {
          //console.log($(this).index());
          var $me = $(this);
          var bioId = $me.attr('class').match(/intro-(\d+)/)[1];
          console.log(bioId);
          $('.card').removeClass('active');
          //$me.addClass('active');
          $('.pix.intro-' + bioId).addClass('active');
          $('.bio.detail-' + bioId).addClass('active');
          setTimeout(function () {
            $('html, body').animate({
              scrollTop: $me.offset().top - 60
            }, 900);
          }, 100);
        });
        $(context).find('a.close').click(function () {
          $('.card').removeClass('active');
        });
        //
        // $('.team-wrapper .card.pix', context).bind('click', function() {
        //   //console.log($(this).index());
        //   let bioId = $(this).attr('class').match(/intro-(\d+)/)[1];
        //   console.log(bioId);
        //   $('html, body').animate({
        //     scrollTop: $(this).offset().top - 60
        //   }, 900);
        //   $('.bio').not(this).removeClass('active');
        //   $('.bio.detail-' + bioId).toggleClass('active', 'active');
        //
        // });
      }
    }
  };

  Drupal.behaviors.reportTable = {
    attach: function attach(context, settings) {

      $('#country-available-reports td.cell').each(function () {
        //console.log($(this).attr('id'));
        //console.log($(this).data('fulltext'));
        var numId = $(this).attr('class').match(/topic-(\d+)/)[1];
        console.log(numId);
        var text = $(this).data('fulltext').trim();
        //console.log(text);
        if (text.indexOf(numId) > -1) {
          $(this).find('.tips').addClass('has-report');
        }
      });
    }
  };

  /**
   * Collapsible items function.
   */
  Drupal.behaviors.collapsibleItem = {
    attach: function attach(context, settings) {
      $('.collapsible-item--title').once().on('click', function () {
        var item = $(this).closest('.collapsible-item');
        item.children('.collapsible-item--content').slideToggle();
        item.toggleClass('collapsible-item--collapsed');
        item.parents('.views-row').toggleClass('views-row__collapsible-item--extended');
      });
    }
  };

  $('.image-gallery').slick({
    infinite        : true,
    slidesToShow    : 3,
    slidesToScroll  : 1,
    mobileFirst     : true
  });


  $('.image-gallery').slickLightbox({
    itemSelector        : 'a',
    navigateByKeyboard  : true,
    caption: function(element, info) { return $(element).find('img').attr('alt');}
  });

  $('.sticky-navigation').on('click', '.search-toggle', function(e) {
    var selector = $(this).data('selector');

    $(selector).toggleClass('show').find('.form-search').focus();
    $(this).toggleClass('active');

    e.preventDefault();
  });



})(jQuery, Drupal, drupalSettings);
"use strict";

(function slickThemeScript($, Drupal) {
  Drupal.behaviors.biofinSlick = {
    attach: function attach(context, settings) {
      var slider = $(".slider");

      slider.each(function () {
        if ($(this).is(".slideshow__slides")) {
          $(this).slick({
            dots: true,
            customPaging: function customPaging(slider, i) {
              return '<a href="#"><i class="fa fa-circle" aria-hidden="true"></i></a>';
            },
            autoplay: true,
            speed: 1500,
            adaptiveHeight: true,
            slidesToShow: 1,
            appendArrows: $('.slideshow__slides'),
            prevArrow: '<div class="left carousel-control"><button class="icon-prev slick-arrow slick-prev"></button></div>',
            nextArrow: '<div class="right carousel-control"><button class="icon-next slick-arrow slick-next"></button></div>',
            responsive: [{
              breakpoint: 768,
              settings: {
                dots: false
              }
            }]
          });
        } else if ($(this).is('.view-publications-carousel')) {
          $(this).slick({
            dots: false,
            autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            speed: 300,
            appendArrows: $('.view-publications-carousel'),
            prevArrow: '<div class="left carousel-control"><button class="icon-prev slick-arrow slick-prev"></button></div>',
            nextArrow: '<div class="right carousel-control"><button class="icon-next slick-arrow slick-next"></button></div>',
            responsive: [{
              breakpoint: 1250,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }, {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }] // end responsie
          }); // end second slice config
        } else {
          $(this).slick();
        } // end of logic
      }); // end of each
    }
  };



})(jQuery, Drupal);
//# sourceMappingURL=script.js.map


(function($) {
  document.addEventListener('DOMContentLoaded', function(event) {
    const wrapper = document.querySelector('.language-switcher-language-url');
    // const wrapperLinks = document.querySelector('.language-switcher-language-url ul.links');
    // create container for selected lang
    const wrapperSelected = document.createElement('div');
    wrapperSelected.classList.add('selected-lang');
    if (wrapper && wrapper.length) {
      wrapper.prepend(wrapperSelected);
    }

    window.setTimeout(function() {
      // get selected lang
      let selectedLang = document.querySelector('.language-switcher-language-url .links a.is-active');
      if (!selectedLang || selectedLang === '') {
        selectedLang = 'English';
      } else {
        selectedLang = selectedLang.textContent;
      }
      //
      wrapperSelected.innerHTML = selectedLang;
      const chevron = document.createElement("i");
      chevron.classList.add("fas");
      chevron.classList.add("fa-chevron-down");
      chevron.style.marginLeft = '10px'
      wrapperSelected.appendChild(chevron);
    }, 1500);
  });

})(jQuery);

(function($) {
  document.addEventListener('DOMContentLoaded', function(event) {
    $('#slide-show-dots').empty(); // Clear any pre-existing content
    $('.block-region-slide-show > div').slick({
      dots: true,
      appendDots: $('#slide-show-dots'),
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }]
    });
  });
})(jQuery);

(function ($, Drupal) {
  Drupal.behaviors.scrollHeader = {
    attach: function (context, settings) {
      $(window).once('scrollHeader').on('scroll', function () {
        if ($(this).scrollTop() > 50) {
          $('#sticknav').addClass('scrolled');
        } else {
          $('#sticknav').removeClass('scrolled');
        }
      });
    }
  };
})(jQuery, Drupal);
